<div class="flex flex-col gap-6">
  <p class="m-0 text-base">
    {{ description }}
  </p>
  <div>
    <span>{{ 'Not sure what to enter?' | translate }}</span>
    <p class="m-0 pt-0 text-sm font-thin italic text-grey-600">
      {{ explanation }}
    </p>
  </div>

  <sb-form-field
    [errorWhen]="['touched']"
    [fullWidth]="true"
    [noPadding]="true"
    [control]="control"
    [label]="fieldLabel"
  >
    <div class="flex flex-row">
      @if (prefix === 'currency') {
        <div class="input-group-addon">{{ '' | currencySymbol }}</div>
      }
      @if (prefix === 'percentage') {
        <div class="input-group-addon">
          <sb-icon size="sm" [name]="'percentage'"></sb-icon>
        </div>
      }
      <decimal-input
        [fullWidth]="true"
        class="w-full"
        [decimals]="2"
        [min]="0"
        [placeholder]="placeholder"
        [defaultValue]="''"
        [formControl]="control"
        [step]="0.01"
      ></decimal-input>
    </div>
  </sb-form-field>
</div>
